const LISTE_CHARGE_TRAVAIL_AFFICHAGE = {
  title: 'Gestion de la charge de travail d\'affichage',
  actions: {
    generer: 'Générer les OT',
    cancel: 'Annuler',
    affecter: 'Affecter',
    addAfficheur: 'Ajouter un afficheur',
  },
  chargeTravailPourPeriode: 'Charge de travail pour la période :',
  showLc: 'Afficher les LC en cours',
  nePasAfficherLc: 'Cacher les LC',
  ressources: 'Afficher la charge de travail ({nbRessources})',
  breadcrumb: {
    racine: 'Accueil',
    listeChargeTravail: 'Gestion charge de travail affichage',
  },
  information: {
    title: 'Information',
  },
  ressourceAndAffectationInfo: {
    nbFaces: '{faces} face(s)',
    nbFacesLp: '{facesLp} laissée(s) en place',
    nbListes: '{listes} liste(s)',
    ot: 'OT',
    title: 'Liste des charges de travail',
    noCharge: 'Aucune charge de travail',
    faceNonAffecte: 'Faces non affectées à une tournée ou à un afficheur',
    titleAffectation: 'Affectation à un afficheur ou à une liste d\'affichage',
    newOt: 'Créer l\'OT',
    removeOt: 'Suppression de l\'OT',
  },
  messages: {
    errors: {
      displayScraping: 'La société doit contenir un produit d\'affichage ainsi qu\'un produit de grattage.',
      villeRequired: 'La ville de l\'afficheur est obligatoire.',
      noOt: 'Vous n\'avez aucun ordre de travail à générer.',
    },
    sucess: {
      otCreate: 'Ordre(s) de travail généré(s) avec succès.',
    },
  },
  popUpAffecter: {
    title: 'Affecter à un afficheur',
    messHeader: 'Voulez-vous vraiment affecter la/les face(s) à cette liste d\'affichage ?',
    sousTitleAfficheur: 'Veuillez choisir un afficheur',
    sousTitleDateListe: 'Veuillez choisir une date ainsi qu\'une liste d\'affichage existante ou alors en créer une temporaire',
    actions: {
      cancel: 'Annuler',
      affecter: 'Affecter',
      noResult: 'Aucun résultat',
      search: 'Recherche...',
    },
    messages: {
      success: {
        affecter: 'La/Les face(s) ont été affectée(s) à une liste avec succès.',
        desaffecter: 'La/les face(s) ont été désaffectée(s) succès.',
        addToOT: 'La/les face(s) ont été ajoutée(s) à un OT',
        affecterTourneeTemp: 'La/Les face(s) ont été affectée(s) à une liste temporaire avec succès.',
      },
      errors: {
        sameWeek: 'La date de départ ne doit pas être sur une semaine différente de la semaine en cours',
        otSave: 'L\'OT doit être à l\'état "enregistré"',
      },
    },
    tourneeAffiche: 'Liste d’affichage',
    listeAfficheur: 'Liste des afficheurs',
    afficheur: 'Affiicheur',
    dateDepart: 'Date de départ',
    agence: 'Agence',
    genererOtFace: 'Générer une liste d\'affichage par face',
  },
  popUpDesaffectation: {
    messHeader: 'Etes-vous sûr de vouloir désaffecter ces faces ?',
  },
};

export default LISTE_CHARGE_TRAVAIL_AFFICHAGE;
